// extracted by mini-css-extract-plugin
export default {"loadingInfo":"DialogStyles_loadingInfo__e5FK3"};